import React, { Component } from 'react';
import { connect } from 'react-redux';
import SocialLinksFooter from 'components/SocialLinksFooter';
import contactImgCopy from 'images/contact-img-copy.svg';

import AlertMessage from 'components/AlertMessage';

import { sendFeedbackAction } from 'store/modules/feedback';
import ContactUsForm from './ContactUsForm';

import ReactPixel from 'react-facebook-pixel';

class ContactUs extends Component {
  state = {
    showAlert: false,
  };

  componentDidMount() {
    ReactPixel.track('Contact');
  }

  sendFeedback = async (values, setSubmitting, setErrors, resetForm) => {
    const { sendFeedbackAction, i18n } = this.props;

    const body = {
      feedback: {
        message: values.message,
        email: values.email,
        name: values.name,
      },
    };
    const response = await sendFeedbackAction(body, setSubmitting, setErrors);
    if (response.status === 201) {
      resetForm();
      this.setState({
        showAlert: true,
      });
      setTimeout(
        () =>
          this.setState({
            showAlert: false,
          }),
        4000,
      );
    }
  };

  render() {
    const { sendFeedbackAction, i18n } = this.props;
    const { showAlert } = this.state;
    return (
      <div className="section contact-us">
        {showAlert && (
          <AlertMessage text={i18n.toast.success.contact_us_submit} />
        )}
        <div className="contact-us__content">
          <div className="b-row">
            <div className="b-col-7 b-col-sm-12">
              <h2 className="h2-title">Contact us</h2>
              <div className="text text-300">
                Whether you have questions or suggestions, we’d love to hear
                from you!
              </div>
              <div className="separator-line" />
              <SocialLinksFooter textTitle="Feel free to contact us on social media" />
              <h2 className="h2-title">Send us a message</h2>
              <div className="separator-line" />

              <ContactUsForm handleSubmit={this.sendFeedback} />
            </div>
            <div className="b-col-5 b-col-sm-12 flex-center">
              <img src={contactImgCopy} alt="" className="feedback-image" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = {
  sendFeedbackAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(ContactUs);



// WEBPACK FOOTER //
// ./src/components/ContactUs/ContactUs.js